module.exports = __webpack_public_path__ + "static/main1_pc-8eff36316d5b2f0a5debf111f1561462.jpg";